<template>
  <div class="wrapper">

    <Background v-if="!loading"/>

    <Nav v-if="!loading" :fixed="true">
      <template v-slot:logo-box>
        <Logo/>
      </template>
      <template v-slot:options-box>
        <DialoguesButton/>
        <Title :title="getTitle"/>
      </template>
      <template v-slot:account-box>
        <AccountButton/>
      </template>
    </Nav>

    <div class="loading" v-if="loading">
      <Loader color="white"/>
    </div>
    
    <div :class="{ main: true }" v-if="!loading">
      <div class="container">

        <div class="dialog">
          <Row v-for="(row, index) in dialog" :key="index" :object="row"/>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import alert from '@/lib/alert'
import { mapActions, mapGetters } from 'vuex';
import Background from '@/components/Watch/Background'
import Row from '@/components/Watch/Row'
import Loader from '@/components/Loader'
//Nav
import Nav from '@/components/Nav/Nav'
import Logo from '@/components/Nav/Logo'
import DialoguesButton from '@/components/Nav/DialoguesButton'
import AccountButton from '@/components/Nav/AccountButton'
import Title from '@/components/Nav/Title'

export default {
  name: 'Watch',
  data() {
    return {
      loading: true,
      dialog: [],
    }
  },
  components: {
    Background,
    Row,
    Loader,
    //Nav
    Nav,
    Logo,
    DialoguesButton,
    AccountButton,
    Title
  },
  methods: {
    ...mapActions('watch', ['clear', 'loadData', 'restart', 'shiftPath', 'nextQuestion']),
    ...mapActions('player', ['playerStop']),
    exit() {
      this.playerStop();
      this.$router.push(`/main`);
    },
    createDialog() {
      let bots = this.getBots;
      let answers = this.getAnswers;
      let path = this.getPath;

      let next = null;
      path.forEach((answerId, index) => {
        if(!next) {
          let answer = answers.find(answer => {
            return answer.id == path[index];
          })
          this.dialog.push({ bot: bots[0], answer})
          next = answer.next;
        } else {
          let answer = answers.find(answer => {
            return answer.id == path[index];
          })
          let bot = bots.find(bot => {
            return bot.id == next;
          })
          this.dialog.push({ bot, answer})
          next = answer.next;
        }
      });
    }
  },
  created() {
    this.playerStop();
    this.clear();
    const urlParams = new URLSearchParams(window.location.search);
    const dialogId = urlParams.get('dialog_id');
    
    this.loadData(dialogId).then(() => {
      this.loading = false;
      this.createDialog();
    }).catch(err => {
      // this.setError(err);
      alert.showError(err);
      this.$router.push('/');
    })
  },
  computed: {
    ...mapGetters('watch', ['getTitle', 'getShortId', 'getExerciseId', 'getDialogOwner', 'getBots', 'getAnswers', 'getPath', 'getRecordings']),
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(62, 64, 70);
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main {
  width: 100vw;
  height: auto;
  z-index: 2;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 5rem;

  @media (min-width: 1600px) {
    width: 100rem;
  }
}

.container {
  width: 100%;
  min-height: calc(100vh - 5rem);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: 
  "dialog dialog dialog"
  "dialog dialog dialog"
  "dialog dialog dialog";

  @media (max-width: 1050px) {
    grid-template-columns: 1fr;
    grid-template-areas: 
    "dialog"
    "dialog"
    "dialog";
  }

  @media (max-width: 750px) {
    min-height: 75vh;
  }
}

.dialog {
  grid-area: dialog;
  width: 100%;
  height: 100%;
  padding-bottom: 4rem;
  padding-top: 3rem;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 750px) {
    padding-bottom: 2rem;
    padding-top: 2rem;
  }
}
</style>